import { buildStandingsFromFixtures } from "./standingsFromFixtures";

const isPlayed = (f) => f.is_forfeit === true || (f.home_team_score != null && f.away_team_score != null);

/** "W" / "D" / "L" / "F" (forfeit) from `teamId`'s side of a played fixture. */
export function resultFor(fixture, teamId) {
  if (fixture.is_forfeit) return "F";
  const home = String(fixture.home_team_id) === String(teamId);
  const mine = Number(home ? fixture.home_team_score : fixture.away_team_score);
  const theirs = Number(home ? fixture.away_team_score : fixture.home_team_score);
  return mine > theirs ? "W" : mine < theirs ? "L" : "D";
}

/**
 * Everything the team page shows, from the division's fixtures (each with embedded
 * `home_team` / `away_team` `{ name, logo_url }`):
 * table row and position, last-five form, results (newest first), upcoming games.
 */
export function buildTeamSummary(teamId, fixtures) {
  const id = String(teamId);
  const teams = new Map();
  for (const f of fixtures || []) {
    if (f.home_team_id != null) teams.set(String(f.home_team_id), { id: f.home_team_id, ...(f.home_team || {}) });
    if (f.away_team_id != null) teams.set(String(f.away_team_id), { id: f.away_team_id, ...(f.away_team || {}) });
  }
  const table = buildStandingsFromFixtures(fixtures || [], [...teams.values()]);
  const position = table.findIndex((r) => String(r.id) === id) + 1;

  const mine = (fixtures || [])
    .filter((f) => String(f.home_team_id) === id || String(f.away_team_id) === id)
    .map((f) => {
      const home = String(f.home_team_id) === id;
      const oppId = home ? f.away_team_id : f.home_team_id;
      return {
        fixture: f,
        home,
        opponent: { id: oppId, ...(teams.get(String(oppId)) || {}) },
        played: isPlayed(f),
        result: isPlayed(f) ? resultFor(f, id) : null,
        goalsFor: home ? f.home_team_score : f.away_team_score,
        goalsAgainst: home ? f.away_team_score : f.home_team_score,
      };
    })
    .sort((a, b) => String(a.fixture.date).localeCompare(String(b.fixture.date)) || String(a.fixture.time || "").localeCompare(String(b.fixture.time || "")));

  const results = mine.filter((g) => g.played).reverse();
  const upcoming = mine.filter((g) => !g.played);
  return {
    row: table[position - 1] || null,
    position: position || null,
    teamCount: table.length,
    leaderPoints: table[0]?.points ?? 0,
    form: results.slice(0, 5).map((g) => g.result).reverse(),
    results,
    upcoming,
    next: upcoming[0] || null,
  };
}
